export default __webpack_public_path__ + "static/logo-and-icons-dark-7e0e6190156ad291bb26562f3f318dbd69daf94b7934133c5b51c44d562a7749.png";